<template>
    <Multiselect
        v-model="selectedValue"
        :disabled="disabled"
        :options="options"
        :placeholder="placeholder"
        :searchable="false"
        :allow-empty="false"
        :label="label"
        :track-by="trackBy"
        :show-labels="false"
        class="select-styling"
    >
        <template #option="optionProps">
            <div class="flex justify-between items-center" :class="{'selected-option': optionProps.option.value === selectedValue?.value}">
                <div>
                    {{ optionProps.option.name }}
                </div>
                <i v-if="optionProps.option.value === selectedValue?.value" class="i-ph-check text-xl"/>
            </div>
        </template>
    </Multiselect>
</template>

<script setup lang="ts">
import {defineProps, defineEmits, computed} from 'vue'
import Multiselect from 'vue-multiselect'

const props = defineProps({
    modelValue: {
        type: Object as () => any,
    },
    disabled: Boolean,
    options: {
        type: Array as () => any[],
        required: true,
    },
    placeholder: {type: String, default: 'Select an option'},
    label: String,
    trackBy: String,
})

const emit = defineEmits(['update:modelValue'])

const selectedValue = computed({
    get: () => props.modelValue,
    set: (modelValue) => emit('update:modelValue', modelValue),
})

</script>

<style scoped>

</style>
